import { Button } from "antd";
import classes from "./AdminManagerBottomPanel.module.css";
import { MANAGER_FORM_ID } from "../../../../constants/adminManagerInfo/managerFormId";
import { IAdminManagerBottomPanelProps } from "../../../../interfaces/props/AdminManagerInfo/IAdminManagerBottomPanelProps";

export const AdminManagerBottomPanel = ({
  cancelButtonProps,
  submitButtonProps,
  className = "",
  ...restProps
}: IAdminManagerBottomPanelProps) => {
  return (
    <div {...restProps} className={`${classes.bottomPanel} ${className}`}>
      <Button {...cancelButtonProps} variant="outlined" color="danger">
        Отмена
      </Button>

      <Button
        color="primary"
        variant="solid"
        htmlType="submit"
        {...submitButtonProps}
        form={submitButtonProps?.form || MANAGER_FORM_ID}
      >
        Сохранить
      </Button>
    </div>
  );
};
